import {
    SHOW_DIALOG,
    HIDE_DIALOG,
} from 'state/actions/CMT/Dialog'

const initialState = {
    dialog: null,
}

export default (state = initialState, action) => {
    switch (action.type) {
    case SHOW_DIALOG: {
        return {
            ...state,
            dialog: action.dialog,
        }
    }
    case HIDE_DIALOG: {
        return {
            ...state,
            dialog: null,
        }
    }
    default:
        return state
    }
}



// WEBPACK FOOTER //
// ./state/reducers/CMT/Dialog.js